import React, { useState } from "react";
import PropTypes from "prop-types";
import { Modal, Form } from "react-bootstrap";
import { Button } from "bootstrap-4-react/lib/components";
import { toast } from "react-toastify";
import { updateFulfillment } from "../../store/actions/dropship.action";

const CARRIERS = ["UPS", "FedEx", "USPS", "DHL", "OnTrac", "LaserShip", "Other"];

export default function ShipModal({ show, onHide, order, onSuccess }) {
    const [trackingNumber, setTrackingNumber] = useState("");
    const [carrierName, setCarrierName] = useState("UPS");
    const [submitting, setSubmitting] = useState(false);

    const handleSubmit = async () => {
        if (!trackingNumber.trim()) {
            toast.error("Please enter a tracking number.");
            return;
        }
        if (!carrierName) {
            toast.error("Please select a carrier.");
            return;
        }

        setSubmitting(true);
        try {
            const result = await updateFulfillment({
                dropshipOrderId: order.id,
                fulfillmentStatus: "Shipped",
                trackingNumber: trackingNumber.trim(),
                carrierName: carrierName,
            });
            if (result.data?.EntityList?.[0]?.success) {
                toast.success("Order marked as shipped.");
                onSuccess?.();
                onHide();
            } else {
                toast.error(result.data?.EntityList?.[0]?.message || "Failed to update fulfillment.");
            }
        } catch (err) {
            toast.error("Failed to update fulfillment.");
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <Modal show={show} onHide={onHide} centered>
            <Modal.Header closeButton>
                <Modal.Title>Mark as Shipped</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="terms-section mb-3">
                    <div className="term-row">
                        <span className="term-label">Order</span>
                        <span className="term-value">{order?.orderNumber}</span>
                    </div>
                    <div className="term-row">
                        <span className="term-label">Product</span>
                        <span className="term-value">{order?.productSKU}</span>
                    </div>
                    <div className="term-row">
                        <span className="term-label">Dropshipper</span>
                        <span className="term-value">Verified Dropshipper</span>
                    </div>
                    <div className="term-row">
                        <span className="term-label">Ship To</span>
                        <span className="term-value">
                            {order?.shipToName}, {order?.shipToCity}, {order?.shipToState} {order?.shipToZip}
                        </span>
                    </div>
                </div>

                <Form.Group className="mb-3">
                    <Form.Label>Carrier</Form.Label>
                    <Form.Select value={carrierName} onChange={(e) => setCarrierName(e.target.value)}>
                        {CARRIERS.map((c) => (
                            <option key={c} value={c}>
                                {c}
                            </option>
                        ))}
                    </Form.Select>
                </Form.Group>

                <Form.Group className="mb-3">
                    <Form.Label>Tracking Number</Form.Label>
                    <Form.Control
                        type="text"
                        placeholder="Enter tracking number"
                        value={trackingNumber}
                        onChange={(e) => setTrackingNumber(e.target.value)}
                    />
                </Form.Group>
            </Modal.Body>
            <Modal.Footer>
                <Button className="cus-primary-transparent-btn" onClick={onHide} disabled={submitting}>
                    Cancel
                </Button>
                <Button className="cus-seconday-bg-btn" onClick={handleSubmit} disabled={submitting}>
                    {submitting ? "Updating..." : "Mark as Shipped"}
                </Button>
            </Modal.Footer>
        </Modal>
    );
}

ShipModal.propTypes = {
    show: PropTypes.bool.isRequired,
    onHide: PropTypes.func.isRequired,
    onSuccess: PropTypes.func,
    order: PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
        orderNumber: PropTypes.string,
        productSKU: PropTypes.string,
        dropshipperName: PropTypes.string,
        shipToName: PropTypes.string,
        shipToCity: PropTypes.string,
        shipToState: PropTypes.string,
        shipToZip: PropTypes.string,
    }).isRequired,
};

ShipModal.defaultProps = {
    onSuccess: undefined,
};
